import React from 'react';
import Table from '@mui/material/Table';
import TableBody from '@mui/material/TableBody';
import TableCell from '@mui/material/TableCell';
import TableContainer from '@mui/material/TableContainer';
import TableHead from '@mui/material/TableHead';
import TableRow from '@mui/material/TableRow';
import Paper from '@mui/material/Paper';
import IconButton from '@mui/material/IconButton';
import EditIcon from '@mui/icons-material/EditRounded';
import DeleteIcon from '@mui/icons-material/DeleteRounded';
import Tooltip from '@mui/material/Tooltip';

export default function TagsTable(props) {

    if ((Array.isArray(props.items)) && (props.items.length === 0)) {
        return null
    }

    return (
        <TableContainer component={Paper}>
            <Table size="small" sx={{ minWidth: 650 }} aria-label="simple table">
                <TableHead>
                    <TableRow>
                        <TableCell sx={{ width: 100 }} align="center">Name</TableCell>
                        <TableCell sx={{ width: 500 }} align="center">Description</TableCell>
                        <TableCell sx={{ width: 80 }} align="center">Actions</TableCell>
                        <TableCell />
                    </TableRow>
                </TableHead>
                <TableBody>
                    {props.items?.map((row) => (
                        <TableRow
                            hover
                            key={row.id}
                            sx={{ cursor: 'pointer' }}
                            onClick={() => { props.btnEditHandle(row) }}
                        >
                            <TableCell align="left">{row.name}</TableCell>
                            <TableCell align="left">{row.description}</TableCell>
                            <TableCell align="center" sx={{ whiteSpace: 'nowrap' }}>
                                <Tooltip arrow title="Edit Tag">
                                    <IconButton 
                                        component="label" 
                                        onClick={() => { props.btnEditHandle(row) }}
                                    >
                                        <EditIcon />
                                    </IconButton>
                                </Tooltip>
                                <Tooltip arrow title="Delete Tag">
                                    <IconButton 
                                        component="label" 
                                        onClick={(e) => {e.stopPropagation(); props.btnDeleteHandle(row) }}
                                    >
                                        <DeleteIcon />
                                    </IconButton>
                                </Tooltip>
                            </TableCell>
                            <TableCell />
                        </TableRow>
                    ))}
                </TableBody>
            </Table>
        </TableContainer>
    );
}
